export default __webpack_public_path__ + "70e6a63756a32109eef7bdf533d04d87.png";